import { render, staticRenderFns } from "./LogoutCard.vue?vue&type=template&id=63090076&"
import script from "./LogoutCard.vue?vue&type=script&lang=js&"
export * from "./LogoutCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports